import { Component, Input } from '@angular/core';
import { ArgyleIncomeStream, IdentityViewBag } from '../models/argyle';

@Component({
  selector: 'app-income-ver-bank-card',
  templateUrl: './income-ver-bank-card.component.html',
  styleUrls: ['./income-ver-bank-card.component.less']
})
export class IncomeVerBankCardComponent {
  @Input() incomeData : ArgyleIncomeStream;
  
}
